import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { BulkWasteAi } from '@digital-platform/rs-bulk-waste-shared/domain';

interface responseAPI {
  Polygons: Polygon[];
}

interface Polygon {
  Polygon_Id: string;
  FAQ: FAQ[];
}

interface FeaturePolygons {
  featureType: string;
  serviceAreaType: string;
  serviceProvider: string;
  name: string;
  infoproDiv: string;
  lawsonDiv: string;
  polygonId: string;
}

interface RequiredPolygonData {
  polygonId: string;
  infoproDiv: string;
  lawsonDiv: string;
}

interface FAQ {
  Question: string;
  Answer: string;
}
@Injectable({
  providedIn: 'root',
})
export class BulkAddressServicesService {
  private API_BASE_URL = '/api/v4';
  private url = `${this.API_BASE_URL}/bulk-waste/`;

  private AIP_BASE_URL_SHOP = '/shopapi/gisservices';

  constructor(private httpClient: HttpClient) {}

  // returns closest match for 'resi' from polygon list
  getSinglePolygon(
    latitude: string,
    longitude: string
  ): Observable<RequiredPolygonData | undefined> {
    return this.getPolygons(latitude, longitude).pipe(
      map((polygonList) => {
        const foundPolygon = polygonList.find(
          (polygon) =>
            // in order of priority/relevance
            polygon.serviceAreaType.includes('Resi Trash') ||
            polygon.serviceAreaType.includes('Resi Recycling') ||
            polygon.serviceAreaType.includes('Resi')
        );

        if (
          !foundPolygon ||
          !foundPolygon.polygonId ||
          !foundPolygon.infoproDiv ||
          !foundPolygon.lawsonDiv
        ) {
          return undefined;
        }

        return {
          polygonId: foundPolygon.polygonId,
          infoproDiv: foundPolygon.infoproDiv,
          lawsonDiv: foundPolygon.lawsonDiv,
        };
      })
    );
  }

  getPolygons(
    latitude: string,
    longitude: string
  ): Observable<FeaturePolygons[]> {
    // query here with latitute and longitude. Example: /shopapi/gisservices/44.854876/-93.460935
    return this.httpClient
      .get<FeaturePolygons[]>(
        `${this.AIP_BASE_URL_SHOP}/${latitude}/${longitude}`
      )
      .pipe(
        map((response) => response),
        catchError((error) => {
          console.error('Error occurred while fetching form:', error);
          throw error;
        })
      );
  }

  getAddressServices(
    polygonId: string,
    infroproDiv: string,
    lawsonDiv: string
  ): Observable<BulkWasteAi> {
    return this.httpClient
      .get<BulkWasteAi>(
        `${this.url}getBulkWaste?polygon_id=${polygonId}&infopro_div=${infroproDiv}&lawson_div=${lawsonDiv}`
      )
      .pipe(
        map((response) => response),
        catchError((error) => {
          console.error('Error occurred while fetching form:', error);
          throw error;
        })
      );
  }
}
